export class ParticipantMetaKeys {
    public static readonly FAVORITE_PROTOCOLS = "favoriteProtocols";
    public static readonly FAVORITE_ACTIVITY_CONFIGS = "favoriteActivityConfigs";
}
